import { articlesList } from "@/mocks/articles";

export default function ArticlesSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="mb-12">
          <span className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-primary-600 mb-3">
            Blog & Guias
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-[1.15]">
            Artigos e Guias
            <br />
            <span className="text-foreground-400">Hoobuy Spreadsheet</span>
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg">
            Guias completos, comparativos e dicas para aproveitar ao máximo sua planilha Hoobuy
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articlesList.map((article) => (
            <a
              key={article.slug}
              href={`/artigo/${article.slug}`}
              className="group flex flex-col bg-background-100 rounded-2xl overflow-hidden hover:bg-background-100/70 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={article.thumbnail}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-950 text-xs font-semibold rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="flex flex-col gap-2 p-5">
                <h3 className="text-sm md:text-base font-bold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between mt-2 pt-3 border-t border-background-200/70">
                  <span className="text-xs text-foreground-400">
                    {new Date(article.date).toLocaleDateString("pt-BR")}
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600">
                    Ler mais
                    <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="/artigo/guia-completo-hoobuy-spreadsheet"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-foreground-950 bg-background-100 hover:bg-background-200/70 rounded-full transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-article-line"></i>
            Ver Todos os Artigos
          </a>
        </div>
      </div>
    </section>
  );
}